import fullscreenlanding from "../../../assets/images/portfolio/fullscreenlanding.webp";
import restaurantwebsite from "../../../assets/images/portfolio/restaurantwebsite.webp";
import parallaxwebsite from "../../../assets/images/portfolio/parallaxwebsite.webp";
import goodvibesform from "../../../assets/images/portfolio/goodvibesform.webp";
import landingpage from "../../../assets/images/portfolio/landingpage.webp";
import bandclone from "../../../assets/images/portfolio/bandclone.webp";
import gournet from "../../../assets/images/portfolio/gournet.webp";
import architect from "../../../assets/images/portfolio/architect.webp";
import parallax2 from "../../../assets/images/portfolio/parallax2.webp";
import ecommerce from "../../../assets/images/portfolio/ecommerce.webp";
import realestate from "../../../assets/images/portfolio/realestate.webp";
import personaltraining from "../../../assets/images/portfolio/personaltraining.webp";
import electrician from "../../../assets/images/portfolio/electrician.webp";

const html_css_projects_data = [
  {
    img: electrician,
    isResponsive: true,
    title: "Electrician Project",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/electrician-project",
    },
    isSeeBtn: {
      isThere: false,
      link: null,
    },
  },
  {
    img: personaltraining,
    isResponsive: true,
    title: "Personal Trainer Project",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/personal-trainer-project",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://adamsteel.surge.sh/",
    },
  },
  {
    img: realestate,
    isResponsive: true,
    title: "Real Estate Project",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/real-estate-project",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://wantedrealestate.surge.sh/",
    },
  },
  {
    img: ecommerce,
    isResponsive: true,
    title: "e-Commerce Project",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/e-commerce-project",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://e-economic.surge.sh/",
    },
  },
  {
    img: parallax2,
    isResponsive: true,
    title: "Parallax2 Website Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: true,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/parallax2-website-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://parallax2clone.surge.sh/",
    },
  },
  {
    img: architect,
    isResponsive: true,
    title: "Architect Website Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: true,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/architect-website-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://architectclone.surge.sh/",
    },
  },
  {
    img: gournet,
    isResponsive: true,
    title: "Gournet Website Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: true,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/gournet-website-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://gournetclone.surge.sh/",
    },
  },
  {
    img: bandclone,
    isResponsive: true,
    title: "Band Website Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: true,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/band-website-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://bandclone.surge.sh/",
    },
  },
  {
    img: landingpage,
    isResponsive: false,
    title: "Landing Page Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/landing-page-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://landingpageclone.surge.sh/",
    },
  },
  {
    img: goodvibesform,
    isResponsive: false,
    title: "Good Vibes Form Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/good-vibes-form-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://goodvibesformclone.surge.sh/",
    },
  },
  {
    img: parallaxwebsite,
    isResponsive: false,
    title: "Parallax Website Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/parallax-website-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://parallaxsiteclone.surge.sh/",
    },
  },
  {
    img: restaurantwebsite,
    isResponsive: false,
    title: "Restaurant Website Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/restaurant-website-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://restaurantwebsiteclone.surge.sh/",
    },
  },
  {
    img: fullscreenlanding,
    isResponsive: false,
    title: "Full Screen Landing Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/full-screen-landing-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://fullscreenlandingclone.surge.sh/",
    },
  },
];

export default html_css_projects_data;
